import type { AmhsDetailLevel } from './amhsDetailLod';

/** Only near machines cast shadows — keeps shadow maps bounded at fab scale. */
export function amhsCastShadow(detail: AmhsDetailLevel): boolean {
  return detail === 'high';
}

export function amhsReceiveShadow(detail: AmhsDetailLevel): boolean {
  return detail === 'high' || detail === 'medium';
}
